import { useState } from "react";
import HomeTemplate from "../../templates/home/home";
import "./homec.scss";

const Home = () => {
   const [showHome, setShowHome] = useState(false);
  return (
    <div className="home">
      <HomeTemplate />
    </div>
  );
};

export default Home;





